import React from "react";
import { addressConstructor } from "common";

import ExternalLink from "../../atoms/externalLink";
import { Icon } from "../../atoms/icon";
import styles from "./index.module.scss";
import { ScheduledEventPlaceItemFragment } from "../../../generated/graphql";
import { BoxLabel, ContentsBox } from "../boxLabel";
import { InterpretedText } from "../../atoms/interpretedText";
import { mapURL } from "../../../lib/fun";

interface Props {
  addressData: ScheduledEventPlaceItemFragment;
  doorsOpenAt: string | null;
  eventTime: string;
}

class AddressBlock extends React.PureComponent<Props> {
  public render() {
    const { addressData, doorsOpenAt, eventTime } = this.props;

    return (
      <div className={styles.addressBlock}>
        <div className={styles.textBlock}>
          {addressData.prefecture.id === 49
            ? "オンライン開催"
            : addressData.address2}
        </div>
        {addressData.prefecture.id !== 49 ? (
          <BoxLabel label="住所" boxSize="smallBox" labelSize="small">
            <ContentsBox boxSize="smallBox">
              <p className={styles.text}>{addressConstructor(addressData)}</p>
            </ContentsBox>
          </BoxLabel>
        ) : null}

        {addressData.prefecture.id !== 49 && (
          <BoxLabel label="Googleマップ" boxSize="smallBox" labelSize="small">
            <ContentsBox>
              {/* TODO: Refactor Icon component and add hover */}
              <div className={styles.linkContainer}>
                <ExternalLink label="地図で見る" to={mapURL(addressData)} />
                <Icon
                  name="external_link"
                  size="extraSmall"
                  className="gmapSrc"
                />
              </div>
            </ContentsBox>
          </BoxLabel>
        )}
        <BoxLabel
          label="アクセス（最寄り駅等）"
          boxSize="smallBox"
          labelSize="small"
        >
          <ContentsBox>
            <p className={styles.text}>{addressData.access}</p>
          </ContentsBox>
        </BoxLabel>
        <BoxLabel label="開催時間" boxSize="smallBox" labelSize="small">
          <ContentsBox>
            <p className={styles.text}>{eventTime}</p>
          </ContentsBox>
        </BoxLabel>
        <BoxLabel label="受付開始時刻" boxSize="smallBox" labelSize="small">
          <ContentsBox>
            <p className={styles.text}>{doorsOpenAt}</p>
          </ContentsBox>
        </BoxLabel>
        <BoxLabel label="当日連絡先" boxSize="smallBox" labelSize="small">
          <ContentsBox>
            <div className={styles.textContainer}>
              <p className={styles.text}>
                <InterpretedText text={addressData.emergencyContact || ""} />
              </p>
            </div>
          </ContentsBox>
        </BoxLabel>
      </div>
    );
  }
}

export { AddressBlock };
